import React from "react";
import { NavLink } from "react-router-dom";

const BottonMenu = ({ w3_close }) => {
  return (
    <div className="game_dock">
      <NavLink
        exact
        to="/wallet"
        activeClassName="dock_active"
        className="dock_item"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/128/6828/6828682.png"
          className="img-fluid"
          alt="menu"
        />
        <span className="dock_label">Wallet</span>
      </NavLink>
      <NavLink
        exact
        to="/refer"
        activeClassName="dock_active"
        className="dock_item"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/128/9592/9592247.png"
          className="img-fluid"
          alt="menu"
        />
        <span className="dock_label">Refer</span>
      </NavLink>

      <NavLink
        exact
        to="/landing"
        activeClassName="dock_active"
        className="dock_item"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/128/10473/10473299.png"
          className="img-fluid"
          alt="menu"
        />
        <span className="dock_label">Home</span>
      </NavLink>

      <NavLink
        exact
        to="/support"
        activeClassName="dock_active"
        className="dock_item"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/128/8743/8743949.png"
          className="img-fluid"
          alt="menu"
        />
        <span className="dock_label">Support</span>
      </NavLink>

      <NavLink
        exact
        to="/Profile"
        activeClassName="dock_active"
        className="dock_item"
      >
        <img
          src="https://cdn-icons-png.flaticon.com/128/17364/17364770.png"
          className="img-fluid"
          alt="menu"
        />
        <span className="dock_label">Profile</span>
      </NavLink>
    </div>
  );
};

export default BottonMenu;
